export const gigsMixin = {
    computed: {
        gigs() {
            return [
                this.$t('gigs.FORSALE'),
                this.$t('gigs.MAIDCOOKING'),
                this.$t('gigs.MAIDCLEANING'),
                this.$t('gigs.MAIDNANNY'),
                this.$t('gigs.TUTOR'),
                this.$t('gigs.DRIVER'),
                this.$t('gigs.SATELLITEDISH'),
                this.$t('gigs.COMPUTERMAINT'),
                this.$t('gigs.CARPENTER'),
                this.$t('gigs.PLUMBER'),
                this.$t('gigs.CARWASH'),
                this.$t('gigs.GARDENER'),
                this.$t('gigs.TRASHPICKUP'),
                this.$t('gigs.BEUTYHAIR'),
                this.$t('gigs.BARBER'),
                this.$t('gigs.BEUTYMAKEUP'),
                this.$t('gigs.MASSAGE'),
                this.$t('gigs.ELECTRICIAN'),
                this.$t('gigs.HOUSEPAINTING'),
                this.$t('gigs.OTHER'),
            ]
        },
    }
}